import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/operators',
        name: 'operators',
        meta: { sideMenuLabel: "Operatori" },
        component: () => import("./views/operators.vue")
    },
];

export default routes;